import apiClient from "./apiClient";



export async function getLayout({
    pageNumber = 0,
    pageSize = 10,
    sortingColumn = 'id',
    direction = 'ASC',
    filters = []
} = {}) {
    const res = await apiClient.post('/minusone-service/layout/getLayout', filters, {
        params: { pageNumber, pageSize, sortingColumn, direction },
    });
    return res.data;
}

export async function addOrUpdate(body) {
    const res = await apiClient.post('/minusone-service/layout/addOrUpdate', body);
    return res.data;
}